import { H1 } from '#ui/H.tsx'
import { HeaderAppWrap } from '#ui/HeaderAppWrap.tsx'
import { Icon } from '#ui/Icon.tsx'

/**
 * Has the general dimensions of the header, is used on the error boundary
 */
export function HeaderAppPlaceholder() {
  return (
    <HeaderAppWrap>
      <div className='flex items-center'>
        <Icon name='heartFilled' />
        <H1 aria-hidden className={x => x('m-0 py-3')}>
          &#x200B;
        </H1>
      </div>
    </HeaderAppWrap>
  )
}
